import { render, staticRenderFns } from "./AddChildPopup.vue?vue&type=template&id=2479a6ea&"
import script from "./AddChildPopup.vue?vue&type=script&lang=js&"
export * from "./AddChildPopup.vue?vue&type=script&lang=js&"
import style0 from "./AddChildPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports